import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarVolumeEstimationPolygon = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.07141 2.28571L8.49998 0.571426L15.9286 2.28571V12.5714L13.0714 15.4286H3.92855L1.07141 12.5714V2.28571Z",
			stroke: "white",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.07141 2.28571L3.92855 5.71428H13.0714L15.9286 2.28571",
			stroke: "white",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.92859 5.71429V14.8571",
			stroke: "white",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0714 5.71429V14.8571",
			stroke: "white",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.64282 12.5714L8.49997 10.2857L15.3571 12.5714",
			stroke: "white",
			strokeLinejoin: "round",
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 10.2857V1.14286",
			stroke: "white",
			strokeLinejoin: "round",
			strokeDasharray: "2 2"
		})
	]
});
export default SvgToolbarVolumeEstimationPolygon;
